
export const environment = {
  production: true,

  tema: 'material',
  jqLicense: '75CE8878-FCD1-4EC7-9249-BA0F153A5DE8', // Licencia para los componentes JqWidgets

  // API NP
  grantTypeApi: 'password',
  clientIdApiNP: 'OGUyYjMwYTMtZGYyMC00NDI3LTg3ZDEtNjIwYTY4YTA5N2Nk',
  clientSecretApiNP: 'NzZkZjQ5MTA4YzNlMDY0NmY0NDIzNzM1N2I3YmZhYTE=',
  userNameApiNP: 'movisat@np',
  passwordApiNP: 'M0v15AT@np2021',

  // API SSO
  grantTypeApiSSO: 'password',
  clientIdApiSSO: 'U32FFNX5AG39DECT',
  clientSecretApiSSO: 'M65Y4L658QNFKQ2PSQWX5S5XEC7WDNBVSV2UH2GRGNZGEUATQX',
  userNameApiSSO: 'movisat@np',
  passwordApiSSO: 'M0v15AT@np2021',

  // API EcoSAT
  grantTypeApiEcoSAT: 'password',
  clientIdApiEcoSAT: 'MJXGWFRCKI',
  clientSecretApiEcoSAT: '083F07174F49A8D65FF40BA91A622122',
  userNameApiEcoSAT: 'android2',
  passwordApiEcoSAT: 'api2014Movisat',

  // API BDT
  grantTypeApiBDT: 'password',
  clientIdApiBDT: '2',
  clientSecretApiBDT: 'HoPqWmkPjUsQ87KIoCl5RriFnkJpBT9vGzFMd9dv',
  userNameApiBDT: 'userNp@movisat.com',
  passwordApiBDT: 'XCsEHZQK7u2IRusb5ffb',

  // API intranet
  grantTypeApiIntranet: 'password',
  clientIdApiIntranet: '2',
  clientSecretApiIntranet: 'mZ0arKrGynWwnNCFUQb4DpR0ZZdqu9AgCbwSEUPE',
  userNameApiIntranet: 'userNp@movisat.com',
  passwordApiIntranet: 'XCsEHZQK7u2IRusb5ffb',

};

